import { pushDataLayerEvent } from '../utils/metricManagementUtil';
import SessionService from '../services/session';

let lastPageView = null

const pageViewDataLayer = ({location}) => {
	if (lastPageView === location.pathname) {
		return
	}
	lastPageView = location.pathname
	const userData = SessionService.getUserData()
	const CryptoJS = require('crypto-js')

	function encrypt(data) {
		if (data) {
			return CryptoJS.SHA256(data).toString();
		} else {
			return undefined
		}
	}

	const dataBrowser = {
		event: 'Page_View',
		location: location.href,
		page: location.pathname.replace(/^\//, ''),
		title: document.title || undefined,
		userId: userData
			? userData.userId
				? encrypt(userData.userId.toString())
				: userData.usuarioId
					? encrypt(userData.usuarioId.toString())
					: undefined
			: undefined,
	}
	pushDataLayerEvent(dataBrowser)
};

export const createOnPreRouteUpdate = () => ({ location }) => {
	pageViewDataLayer({ location })
};
